import { render, staticRenderFns } from "./examine-detail.vue?vue&type=template&id=480fd5ac&scoped=true&"
import script from "./examine-detail.vue?vue&type=script&lang=js&"
export * from "./examine-detail.vue?vue&type=script&lang=js&"
import style0 from "./examine-detail.vue?vue&type=style&index=0&id=480fd5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fd5ac",
  null
  
)

export default component.exports